import { combineReducers } from "redux";
import normalizedReducers from "../utils/normalized/reducers";
import { ModelType } from "./model";

function meta(state = {}, action) {
  return normalizedReducers.metaReducer("CART_PRODUCT", state, action);
}

function byId(state = {}, action) {
  return normalizedReducers.byIdReducer("CART_PRODUCT", state, action);
}

function allIds(state = [], action) {
  return normalizedReducers.allIdsReducer("CART_PRODUCT", state, action);
}

export default combineReducers({ meta, byId, allIds });
